module.exports = __webpack_public_path__ + "static/media/sx.4c05d5c1.svg";